<div
  class="field-editor-container flex flex-row items-stretch overflow-hidden w-full"
>
  <div
    class="field-editor-map flex flex-col flex-1 items-stretch bg-white overflow-hidden"
  >
    <app-field-editor-map [field]="field" [crop]="crop"></app-field-editor-map>
  </div>
</div>
